/*
  Relabels the EasyGift gift picker's confirm button.

  The app hardcodes "Select" and exposes no setting for it, so this is a shim
  rather than a fix. If EasyGift ever adds button text to the rule's popup
  options, set it there and delete this file along with its line in
  layout/theme.liquid.

  Done in JS rather than CSS so the button's accessible name changes too. A
  CSS ::after swap would leave screen readers announcing "Select".

  The app mounts #aca-modal as a direct child of body, so this watches body for
  that one node and only then watches inside it.
*/
(function () {
  var LABEL = 'Add free gift';
  var BUTTON = '.aca-product-button';

  function relabel(root) {
    var buttons = root.querySelectorAll(BUTTON);
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].textContent.trim() !== LABEL) {
        buttons[i].textContent = LABEL;
      }
    }
  }

  function watchModal(modal) {
    relabel(modal);
    // The app re-renders the button when the variant changes.
    new MutationObserver(function () {
      relabel(modal);
    }).observe(modal, { childList: true, subtree: true });
  }

  var existing = document.getElementById('aca-modal');
  if (existing) {
    watchModal(existing);
    return;
  }

  // childList only, no subtree: the modal is appended straight onto body.
  var bodyObserver = new MutationObserver(function () {
    var modal = document.getElementById('aca-modal');
    if (modal) {
      bodyObserver.disconnect();
      watchModal(modal);
    }
  });

  bodyObserver.observe(document.body, { childList: true });
})();
